import { memo } from 'react';
import type { TabIndicatorProps } from './interfaces';
import styles from './style.module.css';

type Props =
    TabIndicatorProps;

const TabIndicator = memo(({ style = {}, ...props }: Props) => {
  const position = props.index + 1;
  const tabsCount = props.count;
  const left = `${(((position) / tabsCount) - (1 / tabsCount)) * 100}%`;
  const width = `${(1 / tabsCount) * 100}%`;

  return (
    <div
      className={styles.indicator}
      style={{ ...style, left, width }} />
  );
});

export default TabIndicator;